exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-nav-button-lines[data-v-92558730] {\n  /*margin-top: 30px;*/\n}\n.h-nav-button-lines .h-nav-button-line[data-v-92558730] {\n  margin-bottom: 13px;\n}\n.h-nav-button-lines .h-nav-button-line .h-nav-button[data-v-92558730] {\n  text-align: center;\n  min-height: 50px;\n  border-radius: 6px;\n  text-transform: none;\n  font-size: 13pt;\n  font-weight: normal;\n}\n@media screen and (min-width: 320px) and (max-width: 480px) {\n.h-nav-links-container[data-v-92558730] {\n    background-color: #EDF1F4;\n    padding: 30px;\n    border-radius: 8px;\n}\n}\n", ""]);

// exports
